import { render, staticRenderFns } from "./ActivityRuleSettings.vue?vue&type=template&id=181395fe&scoped=true"
import script from "./ActivityRuleSettings.vue?vue&type=script&lang=js"
export * from "./ActivityRuleSettings.vue?vue&type=script&lang=js"
import style0 from "./ActivityRuleSettings.vue?vue&type=style&index=0&id=181395fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181395fe",
  null
  
)

export default component.exports